import { GlueInitSettings } from '@glue42/react-hooks';
import GlueWeb from '@glue42/web';

export const glue42Settings: GlueInitSettings = {
    web: {
        factory: GlueWeb,
    },
};
